import apiClient from './apiClient';

export async function fetchSubscription() {
  const { data } = await apiClient.get('/subscription');
  return data;
}

export async function activateSubscription(signedEntitlement) {
  const { data } = await apiClient.post('/subscription/activate', { signedEntitlement });
  return data;
}
